import { useGlobal } from '@/utils/useGlobal';
import AppModal from './AppModal';
import PowerHub from './PowerHub';
import SolarPanels from './SolarPanels';
import LFPBatteries from './LFPBatteries';
import ListD1Modal from './ListD1Modal';
import ListD2Modal from './ListD2Modal';
import css from './index.module.scss';
import CablePack from './CablePack';

export default function Modals({ active, callBack }: any) {
    const { useEffect } = useGlobal();

    useEffect(() => {
        if (active && window) {
            const scrollTo = document.querySelector(`.modals .${active}`) as HTMLElement;
            const scrollElem = document.querySelector(`.modals .modal-content`) as HTMLElement;
            scrollElem.scrollTo({ top: scrollTo?.offsetTop || 0 });
        }
    }, [active]);

    return (
        <div className={`modals ${css.modals}`}>
            <div className="closeBtn" onClick={() => callBack('')}>
                &times;
            </div>
            <div className="modal-content">
                <div className="modal-body">
                    <AppModal />
                    <PowerHub />
                    <CablePack />
                    <LFPBatteries />
                    <SolarPanels />
                    <ListD1Modal />
                    <ListD2Modal />
                </div>
            </div>
        </div>
    );
}
